module.exports = __webpack_public_path__ + "static/media/exp-saphir.1938930c.png";